import { gql } from '@apollo/client';

export const REGISTRATION_LOOKUP = gql`
  mutation RegistrationLookup($customerNumber: String!) {
    registrationLookup(customerNumber: $customerNumber) {
      lookupToken
      maskedEmails { id masked alreadyAssigned }
    }
  }
`;

export const SELECT_REGISTRATION_EMAIL = gql`
  mutation SelectRegistrationEmail($lookupToken: String!, $emailId: ID!) {
    selectRegistrationEmail(lookupToken: $lookupToken, emailId: $emailId) {
      success message
    }
  }
`;

export const REGISTRATION_CONFIRMATION = gql`
  query RegistrationConfirmation($token: String!) {
    registrationConfirmation(token: $token) {
      mode email customerNumber firstName lastName company
      existingCustomerNumberWillBeReplaced
    }
  }
`;

export const CONFIRM_LINK_EXISTING = gql`
  mutation ConfirmLinkExisting($token: String!) {
    confirmLinkExisting(token: $token) { success message }
  }
`;

export const COMPLETE_REGISTRATION = gql`
  mutation CompleteRegistration(
    $token: String!, $firstName: String!, $lastName: String!, $company: String, $password: String!
  ) {
    completeRegistration(
      token: $token, firstName: $firstName, lastName: $lastName, company: $company, password: $password
    ) { success message }
  }
`;
